 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		39: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "static/js/" + ({"0":"@atlaskit-internal_Card","1":"@atlaskit-internal_CardView","2":"@atlaskit-internal_emojiPickerComponent","3":"@atlaskit-internal_emojiTypeAheadComponent","4":"@atlaskit-internal_resourcedEmojiComponent","5":"@atlaskit-internal_editor-core_picker-facade","6":"@atlaskit-internal-renderer-node_Media","7":"@atlaskit-internal-renderer-node_MediaGroup","8":"@atlaskit-internal-editor-core-floating-toolbar","9":"@atlaskit-internal-smartcard-urlcardcontent","10":"@atlaskit-internal-smartcard-datacardcontent","11":"@atlaskit-internal-editor-datepicker","13":"@atlaskit-internal-editor-core-helpdialog","17":"@atlaskit-internal-renderer-node_Status","18":"@atlaskit-internal-renderer-node_Mention","19":"@atlaskit-internal-renderer-node_InlineCard","20":"@atlaskit-internal-renderer-node_Emoji","21":"@atlaskit-internal-renderer-node_DecisionItem","22":"@atlaskit-internal-renderer-node_Date","23":"@atlaskit-internal-renderer-node_BlockCard","29":"@atlaskit-internal_media-editor-view"}[chunkId]||chunkId) + "." + {"0":"3b3ec218","1":"8918a2d3","2":"d7769ada","3":"f65bcfad","4":"7b133b81","5":"949ed9f5","6":"bdbd533f","7":"628fee6e","8":"6bbb0b9d","9":"9b5a224e","10":"10f8d9d9","11":"a21745ad","12":"789f1331","13":"5a7cdbc2","14":"c40f7220","15":"44e37b6e","16":"4b3b2fc0","17":"fbd887d7","18":"20950d18","19":"c86de7fa","20":"66640809","21":"bea48cfe","22":"8077c9aa","23":"edcedf08","24":"2cf9e4ae","25":"d428e6e5","26":"ca0c817a","27":"98cdcaac","28":"c6feb0e6","29":"ad8ddf57","30":"5c0a4d95","31":"53cc3553","32":"390d6e13","33":"d6c4aae6","34":"644947f6","35":"94482a26","36":"01172045","37":"09461270","38":"565e94e4"}[chunkId] + ".chunk.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1397);



// WEBPACK FOOTER //
// webpack/bootstrap b4f2271e4bf164f4e594